import { useIntegratedForm } from '../use-integrated-form';

export function FormLoadFailure(props: { children: React.ReactElement }): React.ReactElement {
    const integratedForm = useIntegratedForm();
    return integratedForm.query.isError ? props.children : <></>;
}
